/* eslint-disable max-len */
import { AppealStatus } from 'feature/appeals/type'
import { useState } from 'react'
import { ModalCloseButton } from 'widget/ModalCloseButton/ModalCloseButton'

import style from './ModalOrderManage.module.scss'
import { OrderManageDateContainerForm } from './OrderManageDateContainerForm/OrderManageDateContainerForm'
import { OrderManageFormContainer } from './OrderManageFormContainer/OrderManageFormContainer'
import { OrderManageMenu } from './OrderManageMenu/OrderManageMenu'

type TModalOrderManage = {
  onClose: () => void
  orderStatus: AppealStatus
  hasPaidOrder: boolean
}

export type TOrderManageType = 'main' | 'cancel' | 'dealer' | 'changeVisit'

//  форма управления заявкой

export function ModalOrderManage({
  onClose,
  orderStatus,
  hasPaidOrder,
}: TModalOrderManage) {
  const [orderManageType, setOrderManageType] =
    useState<TOrderManageType>('main')
  const changeOrderManageType = (type: TOrderManageType) => {
    setOrderManageType(type)
  }

  const handleBack = () => [setOrderManageType('main')]

  return (
    <div className={style.modalContent}>
      <ModalCloseButton
        onClose={onClose}
        showOnMobile
        className={style.closeBtn}
      />
      {orderManageType === 'cancel' && (
        <OrderManageFormContainer
          handleBack={handleBack}
          title='отмена заказа'
          description='Пожалуйста, оставьте заявку, и дилер с Вами свяжется. Чтобы решить вопрос быстрее, Вы можете указать причину отмены.'
          textFieldLabel='Причина отказа'
          onClose={onClose}
          requestType='cancel'
        />
      )}
      {orderManageType === 'dealer' && (
        <OrderManageFormContainer
          handleBack={handleBack}
          title='жалоба на дилера'
          subtitle='Возникли проблемы с текущим дилером?'
          description='Оставьте заявку и мы свяжемся с вами. Чтобы вопрос решился быстрее, 
            вы можете указать причину жалобы.'
          textFieldLabel='Жалоба на дилера'
          onClose={onClose}
          requestType='make-complaint-dealer'
        />
      )}

      {orderManageType === 'changeVisit' && (
        <OrderManageDateContainerForm
          handleBack={handleBack}
          title='Перенос времени заказа'
          description='Пожалуйста, оставьте заявку, и дилер с Вами свяжется. Чтобы решить вопрос быстрее, Вы можете указать причину переноса.'
          onClose={onClose}
        />
      )}

      {orderManageType === 'main' && (
        <OrderManageMenu
          changeOrderManageType={changeOrderManageType}
          orderStatus={orderStatus}
          hasPaidOrder={hasPaidOrder}
        />
      )}
    </div>
  )
}
